/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useEffect, useState } from 'react';
import { CallStatus } from '../typings';
import { Typography, TypographyProps } from '@mui/material';
import { formatDuration } from '../utils/format-duration';

export const CallDurationTimer: React.FC<{
  startTime: number;
  status: CallStatus;
  textProps?: TypographyProps;
}> = ({ startTime, status, textProps }) => {
  const [duration, setDuration] = useState(0);

useEffect(() => {
    if (status === CallStatus.END) {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      setDuration(elapsed);
      return;
    }
    if (status === CallStatus.IN_PROGRESS) {
      const updateDuration = () => {
        const now = Date.now();
        const elapsed = Math.max(0, Math.floor((now - startTime) / 1000));
        setDuration(elapsed);
      };

      updateDuration();
      const interval = setInterval(updateDuration, 1000);
      return () => clearInterval(interval);
    }
  }, [startTime, status]);

  if (status !== CallStatus.IN_PROGRESS && status !== CallStatus.END) {
    return null;
  }

  return (
    <Typography
      sx={{
        fontSize: '12px',
        fontWeight: 400,
        color: '#ffffff',
        minWidth: duration < 3600 ? '36px' : '54px'
      }}
      {...textProps}
    >
      {formatDuration(duration)}
    </Typography>
  );
};
